import React, { useState } from "react";
import { BASE_URL } from "utils/utils";
import { toast } from "react-toastify";
import { handleDeleteAds, handleToggleAdsStatus } from "actions/actions";
import profileImage from "../assets/img/avatars/profileImage.jpg";
import ImageModal from "../components/imageModel/imageMode.jsx";

const audienceLabels = {
  all: "الجميع",
  user: "العملاء",
  contractor: "المقاولون",
  supplier: "الموردون",
};

const AdsColumns = (refetch) => [
  {
    Header: "اسم المستخدم",
    accessor: "name",
    Cell: ({ row }) => {
      return (
        <div className="flex items-center gap-2">
          <span>{row.original.user?.name}</span>
        </div>
      );
    },
  },
  {
    Header: "رقم الهاتف",
    accessor: "user.phoneNumber",
    Cell: ({ row }) => {
      return <span>{row.original.user?.phoneNumber}</span>;
    },
  },
  {
    Header: "الصورة",
    accessor: "photo",
    Cell: ({ row }) => {
      const [isModalOpen, setIsModalOpen] = useState(false);

      const handleImageClick = () => {
        setIsModalOpen(true);
      };

      const handleCloseModal = () => {
        setIsModalOpen(false);
      };

      return (
        <>
          <img
            src={
              row.values.photo
                ? BASE_URL + "/" + row.values.photo
                : profileImage
            }
            alt={row.values.id}
            className="h-12 w-12 cursor-pointer rounded-lg object-cover"
            crossOrigin="anonymous"
            onClick={handleImageClick}
          />
          {isModalOpen && (
            <ImageModal
              src={
                row.values.photo
                  ? BASE_URL + "/" + row.values.photo
                  : profileImage
              }
              onClose={handleCloseModal}
            />
          )}
        </>
      );
    },
  },
  {
    Header: "الحالة",
    accessor: "status",
    Cell: ({ row }) => {
      return (
        <span
          className={`rounded-full px-2 py-1 text-xs font-semibold ${
            row.values.status === "active"
              ? "bg-green-100 text-green-800"
              : "bg-red-100 text-red-800"
          }`}
        >
          {row.values.status === "active" ? "مفعل" : "غير مفعل"}
        </span>
      );
    },
  },
  {
    Header: "يظهر لـ",
    accessor: "targetAudience",
    Cell: ({ row }) => {
      const targetAudiences = row.original.targetAudiences || [];
      const value =
        targetAudiences.length > 0
          ? targetAudiences.length === 3
            ? audienceLabels.all
            : targetAudiences
                .map((role) => audienceLabels[role] || role)
                .join("، ")
          : audienceLabels[row.values.targetAudience || "all"];
      return (
        <span className="rounded-full bg-blue-100 px-2 py-1 text-xs font-semibold text-blue-800">
          {value}
        </span>
      );
    },
  },
  {
    Header: "تاريخ الإنشاء",
    accessor: "createdAt",
    Cell: ({ row }) => {
      console.log(row.values.createdAt);
      const date = new Date(row.values.createdAt).toLocaleString("ar-EG", {
        year: "numeric",
        month: "numeric",
        day: "numeric",
        hour: "numeric",
        minute: "numeric",
      });
      return <span>{date}</span>;
    },
  },
  {
    Header: "تاريخ البداية",
    accessor: "startDate",
    Cell: ({ row }) => {
      const value = row.values.startDate;
      if (!value) return <span>لا يوجد</span>;

      const date = new Date(value).toLocaleString("ar-EG", {
        year: "numeric",
        month: "numeric",
        day: "numeric",
        hour: "numeric",
        minute: "numeric",
      });

      return <span>{date}</span>;
    },
  },
  {
    Header: "تاريخ النهاية",
    accessor: "endDate",
    Cell: ({ row }) => {
      const value = row.values.endDate;
      if (!value) return <span>لا يوجد</span>;

      const date = new Date(value).toLocaleString("ar-EG", {
        year: "numeric",
        month: "numeric",
        day: "numeric",
        hour: "numeric",
        minute: "numeric",
      });

      return <span>{date}</span>;
    },
  },

  {
    Header: "إجراء",
    accessor: "id",
    Cell: ({ row }) => {
      return (
        <div className="flex flex-col items-start gap-2">
          {row.original.status === "active" ? (
            <button
              className="rounded-full bg-red-400 px-6 py-1 text-white transition-all hover:bg-red-500 disabled:cursor-not-allowed disabled:bg-gray-300 disabled:text-gray-400"
              onClick={() =>
                handleToggleAdsStatus(row.original.id, "inactive").then(
                  (res) => {
                    if (res.error) {
                      toast.error(res.error);
                    } else {
                      toast.success(res.success);
                      refetch();
                    }
                  }
                )
              }
            >
              إلغاء التفعيل
            </button>
          ) : (
            <button
              className=" rounded-full bg-green-500 px-6 py-1 text-white transition-all hover:bg-green-600 disabled:cursor-not-allowed disabled:bg-gray-300 disabled:text-gray-400"
              onClick={() =>
                handleToggleAdsStatus(row.original.id, "active").then((res) => {
                  if (res.error) {
                    toast.error(res.error);
                  } else {
                    toast.success(res.success);
                    refetch();
                  }
                })
              }
            >
              تفعيل
            </button>
          )}
          <button
            className="rounded-full bg-red-700 px-6 py-1 text-white transition-all hover:bg-red-900 disabled:cursor-not-allowed disabled:bg-gray-300 disabled:text-gray-400"
            onClick={() =>
              handleDeleteAds(row.original.id).then((res) => {
                if (res.error) {
                  toast.error(res.error);
                } else {
                  toast.success(res.success);
                  refetch();
                }
              })
            }
          >
            حذف
          </button>
        </div>
      );
    },
  },
];

export { AdsColumns };
